import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { Button, DropDown } from "@/components/index";
import { useSubscriptionsContext } from "@/contexts/subscriptions";
import { makeSubsReadUrl } from "@/shared/utils/subscriptions";
import { SubscribeIcon, ChevronLeftIcon, ChevronRightIcon } from "../../../assets/CommonIcons";

import styles from "./subscriptionSwitcher.module.scss";

const SubscriptionSwitcher = ({
  subscriptionContent,
  currentIndex
}) => {
  const { t } = useTranslation();
  const { date } = useSubscriptionsContext();
  const router = useRouter();

  const onNavByList = (diff) => {
    router.replace(makeSubsReadUrl(date, subscriptionContent[currentIndex + diff].book_id));
  };

  const onSelectHandler = (bookId) => {
    router.replace(makeSubsReadUrl(date, bookId));
  };

  return (
    <div className={styles["subs-switcher"]}>
      <Button
        disabled={!subscriptionContent[currentIndex - 1]}
        className={styles["subs-switcher-icon"]}
        onClick={() => onNavByList(-1)}
      >
        <ChevronLeftIcon />
      </Button>

      <DropDown
        button={({ show, onClick }) => {
          return (
            <Button
              active={show}
              title={t("subscriptionsList")}
              className={classNames(
                styles["subs-switcher-icon"],
                styles["subs-switcher-icon-bird"]
              )}
              onClick={onClick}
            >
              <SubscribeIcon />
            </Button>
          );
        }}
        body={({ hide }) => (
          <div className={styles["popup-subs-list"]}>
            {subscriptionContent.map((item, index) => (
              <div
                key={item.book_id}
                className={classNames(styles["popup-subs-item"], {
                  [styles["is-active"]]: currentIndex === index
                })}
                onClick={() => {
                  onSelectHandler(item.book_id);
                  hide();
                }}
              >
                <span className={styles["popup-subs-item-text"]}>{item.book_title}</span>
              </div>
            ))}
          </div>
        )}
      />
      <Button
        disabled={!subscriptionContent[currentIndex + 1]}
        className={styles["subs-switcher-icon"]}
        onClick={() => onNavByList(1)}
      >
        <ChevronRightIcon />
      </Button>
    </div>
  );
};

SubscriptionSwitcher.propTypes = {
  currentIndex: PropTypes.number,
  subscriptionContent: PropTypes.array
};

export default SubscriptionSwitcher;
